
import Axios from '../common/http.js';

/**
 * 生成分享数据
 */
export const resourceShare = (data) => {
	return Axios.post('/go/api/teacher/netDisk/resource/share', data);
};

/**
 * 生成小程序码
 */
export const createQrCode = (data) => {
	return Axios.post('/api/teacher/qr_code', data);
};